import {fromJS} from 'immutable';

const initUserData = {
  
}

const initRoleData = {
  
}

export function userData(
  state = initUserData,
  action
) {
  switch (action.type) {
    case "USER_FETCH_DATA_SUCCESS":
      return action.dataUser;
    default:
      return state;
  }
}

export function roleData(
  state = initRoleData,
  action
) {
  switch (action.type) {
    case "ROLE_FETCH_DATA_SUCCESS":
      return action.dataRole;
    default:
      return state;
  }
}

export function userDetail(
  state = fromJS({}),
  action
){
  switch (action.type) {
    case 'USER_FETCH_DETAIL_SUCCESS':
      return fromJS(action.detail)
    default:
      return state
  }
}

export function roleDetail(
  state = fromJS({}),
  action
){
  switch (action.type) {
    case 'ROLE_FETCH_DETAIL_SUCCESS':
      return fromJS(action.roledetail)
    default:
      return state
  }
}